<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-回访-添加
    -->
    <el-dialog
    title="修改服务商"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true" 
    width="50%"
  >
  <div class="active-basic">
  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改服务商</div>

      <!-- <el-form-item label="绑定招商中心" > 
        <el-row>
          <el-button @click="addFilialeClick" icon="el-icon-plus">绑定招商中心</el-button>
          <div v-if="form.filiale_id!=''" class="img">
            <img :src="filiale_info.avatarUrl" width="100" height="100" />
            <div>名称：{{ filiale_info.name }}</div>
          </div>
      
        </el-row>
      </el-form-item> -->



      <el-form-item label="选择角色" prop="service_role_id">
        <el-select v-model="form.service_role_id" @change="changeRole">
          <template v-for="(item,index) in serviceRoleList">
            <el-option
              :value="item.service_role_id"
              :key="index"
              :label="item.name"
            ></el-option>
          </template>
        </el-select>
      </el-form-item>

         
      <el-form-item label="选择上级"  v-if="getLevel() > 0"> 
        <el-row>
          <el-button  @click="addServiceClick" icon="el-icon-plus">选择上级</el-button>
          <div v-if="form.service_id!=''" class="img">
            <img v-if="service_info.avatarUrl" :src="service_info.avatarUrl" width="100" height="100" />
            <div v-if="service_info.name">名称：{{ service_info.name }}</div>
          </div>
        </el-row>
      </el-form-item>




      <el-form-item label="服务商名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入服务商名称" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="服务商Logo" prop="image_id">
      <div class="d-c-c ad-picture" @click="openUpload">
        <img v-if="form.avatarUrl" :src="form.avatarUrl" width="124" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>
    </el-form-item>


      <el-form-item label="选择用户">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
            <div>昵称：{{ user_info.nickName }}</div>
          </div>
         
        </el-row>
      </el-form-item>

      <el-form-item label="联系人" prop="nickname">
        <el-input v-model="form.nickname" placeholder="请输入联系人" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="联系电话" prop="mobile">
        <el-input v-model="form.mobile" placeholder="请输入联系电话" class="max-w460"></el-input>
      </el-form-item>

    
      <el-form-item label="地址"  prop="address" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.address" :disabled="true" placeholder="请输入地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input :disabled="true" v-model="form.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row>
        <el-row class="mb16">
          <el-col :span="24">
            <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
          </el-col>
        </el-row>

      </el-form-item>



      <el-form-item label="状态" prop="status">
      <div >
          <el-radio-group v-model="form.status">
            <el-radio  :label="1" >启用</el-radio>
            <el-radio  :label="0" >停用</el-radio>
          </el-radio-group>
      </div>
      </el-form-item>
      


    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</div>
  <GetUser :is_open="open_add_user" :excludeIds="excludeIds" :multi="multi" @close="closeDialogFunc"></GetUser>
  <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>

  <Service :is_open="open_add_service" 
    :level="getLevel()>0?(getLevel()-1):-1"
  :excludeIds="excludeIds" :multi="multi" @close="closeDialogFuncService"></Service>
</el-dialog>
  
</template>

<script>
import ServiceApi from '@/api/service.js';
import Getpoint from '@/components/map/Getpoint.vue';
import GetUser from '@/components/user/GetUser.vue';
import Upload from '@/components/file/Upload';
import Filiale from '@/components/fs/filiale.vue';

import Service from '@/components/fs/service.vue';
export default {
  components: {
    Getpoint,
    GetUser,
    Upload,
    Service,
  },
  data() {
    return {

      /*form表单数据*/
      form: {
        name: '',
        nickname:"",
        mobile:"",
        user:{},
        status:1,
        user_id:"",
        avatarUrl:"",
        filiale_id:"",

        province_id:"",
        city_id:"",
        region_id:"",
        province:"",
        city:"",
        region:"",
        address:"",
        longitude:"",
        latitude:"",
        service_role_id:0,
        parent_id:0



      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入服务商名称', trigger: 'blur' }],
        nickname: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        service_role_id: [{ required: true, message: '请选择角色', trigger: 'blur' }],
      },
      dialogVisible:false,
      user_info:{},
         /*是否打开添加弹窗*/
         open_add_user: false,
         excludeIds:[],
         multi:false,
         isupload:false,

         filiale_id:0,
        filiale_info:{

        },
        open_add_filiale:false,
        serviceRoleList:[],
        serviceList:[],

        open_add_service:false,
                
    
                service_info:{
        
                },
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.getServiceRole()
    this.getService();
    
  },
  props: ["open_add","service_id"],
  methods: {
    changeRole(){
      this.getService();
      this.form.parent_id = 0;
    },
    getLevel(){
      let level = 0;
      for(var i=0;i<this.serviceRoleList.length;i++){
          if(this.serviceRoleList[i]["service_role_id"] == this.form.service_role_id){
            level = this.serviceRoleList[i]["level"];
          }
      }
      return level;
    },
    getServiceRole(){
      var self = this;
      ServiceApi.getServiceRole({
      
      }, true)
            .then(data => {
              self.serviceRoleList = data.data
    
      });
    },   
    getService(){
      var self = this;
      ServiceApi.getService({
        current_level:self.getLevel(),
        service_id: self.service_id,
      }, true)
            .then(data => {
              self.serviceList = data.data
    
      });
    },   
    /*打开弹出层*/
    addFilialeClick() {
        this.open_add_filiale = true;
      },



         /*获取图片*/
         returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.avatarUrl = e[0].file_path;

      }
      this.isupload = false;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },
    
      /*打开弹出层*/
      addClick() {
        this.open_add_user = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params;
          this.form.user_id = e.params.user_id;
        }
        this.open_add_user = false;
      },
      /*选择的地址*/
      choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;

      },
       /*获取经纬度*/
       getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
       /*打开弹出层*/
       addServiceClick() {
        this.open_add_service = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFuncService(e) {
        if (e.type != 'error') {
          this.service_info = e.params;
          this.form.parent_id = e.params.service_id;
        }
        this.open_add_service = false;
      },

    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      ServiceApi.detail({
        service_id: self.service_id,
        current_level:self.form.parent_id
      },true).then(res => {
          self.form = res.data;
          if(self.form.user && self.form.user.user_id){
            self.excludeIds.push(self.form.user.user_id)
          }
          self.user_info = self.form.user;
          self.service_info = self.form.service
          self.form.user_id = self.form.user.user_id
          self.form.service_id = self.form.service.service_id
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.service_id = self.service_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          ServiceApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
  }
};
</script>

<style  lang="scss">
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
.active-basic .ad-picture {
  width: 124px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/service/service/part/edit.vue